var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTheme } from 'styled-components';
export var Arrow = function () {
    var theme = useTheme();
    return (_jsxs("svg", __assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [_jsx("g", __assign({ clipPath: "url(#clip0_5177_6391)" }, { children: _jsx("path", { d: "M10.0001 6L8.59009 7.41L13.1701 12L8.59009 16.59L10.0001 18L16.0001 12L10.0001 6Z", fill: theme.colors.textBodyMain }) })), _jsx("defs", { children: _jsx("clipPath", __assign({ id: "clip0_5177_6391" }, { children: _jsx("rect", { width: "24", height: "24", fill: "white" }) })) })] })));
};
